/**
 * DetectTouchController
 *
 * @author Manuel Müller <manuel.mueller@pluswerk.ag>
 */
Pluswerk.PlusProject.Utility.DetectTouchController = function () {
    if (isTouchDevice()) {
        $html.addClass('touch');
    }

    function isTouchDevice() {
        return (('ontouchstart' in window)
            || (navigator.maxTouchPoints > 0)
            || (navigator.msMaxTouchPoints > 0));
    }
};
